import React, { Component } from 'react';
import { Row, Col, Card, CardBody, FormGroup, Button, Label, Spinner, Modal, ModalHeader, ModalBody } from "reactstrap";
import { AvForm } from "availity-reactstrap-validation";
import "react-datepicker/dist/react-datepicker.css";
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import Select from "react-select";
import BootstrapTable from "react-bootstrap-table-next";
import { Link } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
import { BaseUrl } from "../../helpers/Baseurl";
import { get } from '../../helpers/api_helper';

class DestinationDetail extends Component {
    constructor(props) {
        super(props);

        this.state = {
            locationloading: false,
            itinerary: this.props.data,
            destinationData: [],
            selectedDestination: { label: 'Select Destination', value: null },
            selectedVisitingLocation: [],
            DestinationGroup: this.props.DestinationGroup,
            DestinationsLocationGroup: [],
            destination_id: "",
            itinerary_places: [],
            itinerary_destinations: [],
            is_mounted: false,
            loading: false,
        };

        toastr.options = {
            positionClass: "toast-top-right",
            closeButton: "false",
            progressBar: "true",
            showEasing: "swing",
            hideEasing: "linear",
            showMethod: "fadeIn",
            hideMethod: "fadeOut",
            showDuration: 300,
            hideDuration: 1000,
            timeOut: 5000,
            extendedTimeOut: 1000,
        };

        this.tog_editLocations = this.tog_editLocations.bind(this);
        this.handleSaveDestinations = this.handleSaveDestinations.bind(this);
        this.onDestinationInputChange = this.onDestinationInputChange.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
        this.handleselectedDestination = this.handleselectedDestination.bind(this);
        this.handleSelectedVisitingLocation = this.handleSelectedVisitingLocation.bind(this);
    } 
    
    tog_editLocations() {
        this.setState(prevState => ({
            model_editLocations: !prevState.model_editLocations
        }));
        this.removeBodyCss();
    }

    removeBodyCss() {
        document.body.classList.add("no_padding");
    }

    componentDidCatch(error) {
        console.log(error);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.data !== this.props.data) {
            this.setState({
                itinerary: this.props.data,
                locationloading: false,
                model_editLocations: false
            });
            this.loadDestinationAndPlaceData(this.props.data);
        }
    }

    componentWillUnmount() {
        this.setState({ is_mounted: false });
    }

    componentDidMount() { 
        this.setState({ is_mounted: true });
        this.loadDestinationAndPlaceData(this.props.data);   
    }

    loadDestinationAndPlaceData = (itinerary) => {
        let itinerary_places = [];
        let itinerary_destinations = [];
        let destination = itinerary.destinations;
        let place = itinerary.places;
        let data = [];
        for (let i = 0; i < destination.length; i++) {
            itinerary_destinations.push(destination[i]?.id);
            let place_list = "";
            for (let j = 0; j < place.length; j++) {
                if (place[j].parent?.id && destination[i].id === place[j].parent?.id) {
                    itinerary_places.push(place[j].id);
                    place_list = place_list === "" ? place_list + place[j].name : place_list + ", " + place[j].name;
                } 
            }
            let new_data = { id: destination[i].id, destination: destination[i].name, places: place_list };
            data.push(new_data);
        }
        this.setState({ destinationData: data, itinerary_places, itinerary_destinations });
    }

    onDestinationInputChange = (e) => {
        const requestOptions = {
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.props.access}` },
        };
        get(`${BaseUrl}/api/locations/location/locations/?parent=null&search=${e}&size=50`, requestOptions)
        .then(response => {
            let options = [];
            response.results.map(destination => {
                options.push({ label: destination.name, value: destination.id });
            });
            let DestinationGroup = [
                { 
                    label: "Destination",
                    options: options
                }
            ];
            this.setState({ DestinationGroup });      
        });
    }
    
    async loadDestinationPlaces(filer_queryset) {
        console.log("DATA DESTINATIONS");
        this.setState({ DestinationsLocationGroup: [], loading: true });
        const requestOptions = {
            method: 'GET',
            headers: { 
                'Content-Type': 'application/json', 
                'Authorization': `Bearer ${this.props.access}` 
            },
        };
        try {
            const response = await get(`${BaseUrl}/api/locations/location/locations/${filer_queryset}`, requestOptions);
            if (response.results) {
                const options = response.results.map(destination => ({
                    label: destination.name,
                    value: destination.id
                }));
                const allOption = { label: "Select All", value: "all" };
                const DestinationsLocationGroup = [
                    { 
                        label: "Places", 
                        options: [allOption, ...options] 
                    }
                ];
                this.setState({ DestinationsLocationGroup });
            }
        } catch (error) {
            console.error("Error fetching locations:", error);
        } finally {
            this.setState({ loading: false });
        }
    }

    onInputChange(e) {
        let DestinationsLocationGroupOld = [];
        this.setState({ DestinationsLocationGroupOld }); 
        console.log("CHANGE");
        let loading = true;
        this.setState({ loading }); 
        const { selectedDestination } = this.state;
        if (selectedDestination.value) {
            this.loadDestinationPlaces(`?parent__id=${selectedDestination.value}&search=${e}&size=50`);
        }
    }

    handleselectedDestination(selectedDestination) {
        let selectedVisitingLocation = [];
        if (!this.state.itinerary_destinations.includes(selectedDestination.value)) {
            this.loadDestinationPlaces(`?parent__id=${selectedDestination.value}`);
        } else {
            toastr.error(`${selectedDestination.label} Already Added`);
            selectedDestination = { label: 'Select Destination', value: null };
        }
        if (this.state.is_mounted) {
            this.setState({ selectedDestination, selectedVisitingLocation });
        }
    }

    handleSelectedVisitingLocation(selectedVisitingLocation) {
        const { DestinationsLocationGroup } = this.state;

        if (!selectedVisitingLocation || selectedVisitingLocation.length === 0) {
            this.setState({ selectedVisitingLocation: [] });
            return;
        }

        const isAllSelected = selectedVisitingLocation.some(option => option.value === "all");

        if (isAllSelected) {
            const allOptions = DestinationsLocationGroup[0].options.filter(option => option.value !== "all");
            this.setState({ selectedVisitingLocation: allOptions });
        } else {
            this.setState({ selectedVisitingLocation });
        }
    }

    handleSaveDestinations() {
        const { itinerary_destinations, itinerary_places, selectedVisitingLocation, selectedDestination } = this.state;
        
        if (selectedVisitingLocation.length === 0) {
            toastr.error("Select Visiting Places", ""); 
        } else {
            this.setState({ locationloading: true });
    
            let destini = [...itinerary_destinations];
            let selected_places = [...itinerary_places];
    
            destini.push(selectedDestination.value);
            selectedVisitingLocation.forEach(location => {
                selected_places.push(location.value);
            });
    
            let data = {
                destinations: destini,
                places: selected_places
            };
    
            this.props.SaveItineraryData(data)
                .then(() => {
                    this.setState({
                        locationloading: false,
                        model_editLocations: false
                    });
                    toastr.success("Updated successfully!");
                })
                .catch(error => {
                    console.error("Error updating:", error);
                    this.setState({ locationloading: false });
                    toastr.error("Update failed, please try again.");
                });
        }
    }
    
    handleAdd(id) {
        let { itinerary } = this.state;
        let selectedDestination = { label: 'Select Destination', value: null };
        let selectedVisitingLocation = [];
    
        const selectedDest = itinerary.destinations.find(dest => dest.id === id);
        if (selectedDest) {
            selectedDestination = { label: selectedDest.name, value: selectedDest.id };
            this.loadDestinationPlaces(`?parent__id=${selectedDest.id}&size=50`);
        }
    
        let itinerary_destinations = this.state.itinerary_destinations.filter(dest_id => dest_id !== id);
        // let selectedPlaces = itinerary.places.filter(place => place.parent?.id === id);
        let selectedPlaces = itinerary.places.filter(place => place.parent.id === id);

        selectedVisitingLocation = selectedPlaces.map(place => ({
            label: place.name,
            value: place.id
        }));
    
        let itinerary_places = this.state.itinerary_places.filter(place_id =>
            !selectedPlaces.some(place => place.id === place_id)
        );
    
        this.setState({ 
            selectedDestination, 
            selectedVisitingLocation, 
            itinerary_places, 
            itinerary_destinations 
        }, () => {
            this.tog_editLocations();
        });
    }
    
    handleDeleteDestination(id) {
        let itinerary_places = this.state.itinerary_places;
        let itinerary_destinations = this.state.itinerary_destinations;
        let destination = this.state.itinerary.destinations;
        let places = this.state.itinerary.places;
        for (let i = 0; i < destination.length; i++) {
            if (destination[i].id === id) {
                let destini_index = itinerary_destinations.indexOf(destination[i].id);
                if (destini_index >= 0) {
                    itinerary_destinations.splice(destini_index, 1);
                }
                for (let j = 0; j < places.length; j++) {
                    const parent = places[j].parent;
                
                    if (parent && id === parent.id) {
                        let index = itinerary_places.indexOf(places[j].id);
                        if (index >= 0) {
                            itinerary_places.splice(index, 1);
                        }
                    }
                }
                
            } 
        }
        let data = {
            destinations: itinerary_destinations,
            places: itinerary_places
        };
        this.props.SaveItineraryData(data);
        this.setState({
            destination_id: "",
            destination_success_confirm: true,
            destination_alert_confirm: false,
            dynamic_title: "Deleted!",
            dynamic_description: "Destination has been removed."
        });
    }

    render() {
        const { destinationData, itinerary } = this.state;
        const DestinationColumns = [
            {
                dataField: "id",
                text: "id",
                hidden: true,
            },           
            {
                dataField: "destination",
                text: "Destination",
                headerStyle: { backgroundColor: '#fcb92c' },
            },
            {
                dataField: "places",
                text: "Visiting Places",
                headerStyle: { backgroundColor: '#fcb92c' },
            },
            {
                dataField: "menu",
                isDummyField: true,
                text: "Action",
                editable: false,
                headerStyle: { backgroundColor: '#fcb92c', width: "10%" },
                formatter: (cellContent, row) => { 
                    return (
                        <React.Fragment>
                            <div style={{ textAlign: "center" }}>
                                <Link to="#" onClick={() => this.handleAdd(row.id)} className="text-secondary me-2">
                                    <i className="mdi mdi-lead-pencil font-size-18"></i>
                                </Link>
                                <Link to="#" onClick={() => this.setState({ destination_alert_confirm: true, destination_id: row.id })} className="text-danger">
                                    <i className="mdi mdi-trash-can font-size-18"></i>
                                </Link> 
                            </div>
                        </React.Fragment>
                    );
                }
            },
        ];
        const DestinationColumnsnotEdit = [
            {
                dataField: "id",
                text: "id",
                hidden: true,
            },           
            {
                dataField: "destination",
                text: "Destination",
                headerStyle: { backgroundColor: '#fcb92c', width: "10%" },
            },
            {
                dataField: "places",
                text: "Visiting Places",
                headerStyle: { backgroundColor: '#fcb92c' },
            },
        ];

        return (
            <React.Fragment key={"destination-Detail"}>
                <Row>
                    <Col xs={12}>
                        <Card>
                            {!["tour completed"].includes(itinerary.status) && this.props.user.role !== 1 ?
                                <CardBody>
                                    <div className="table-responsive">
                                        <BootstrapTable
                                            keyField="id"
                                            data={destinationData}
                                            columns={DestinationColumns}
                                        />
                                    </div>
                                    <div style={{ textAlign: "center" }}>
                                        <Button color="secondary" outline className="waves-effect me-1 mb-3" onClick={() => this.handleAdd()}>
                                            Add Destination
                                        </Button>
                                    </div>
                                </CardBody>
                            :
                                <CardBody>
                                    <div className="table-responsive">
                                        <BootstrapTable
                                            keyField="id"
                                            data={destinationData}
                                            columns={DestinationColumnsnotEdit}
                                        />
                                    </div>
                                </CardBody>
                            }
                        </Card>
                    </Col>
                </Row>
                <Col sm={6} md={4} xl={3} className="mt-4">
                    <Modal
                        isOpen={this.state.model_editLocations}
                        toggle={this.tog_editLocations}
                        centered={true}
                        backdrop="static"
                    >
                        <ModalHeader toggle={this.tog_editLocations}>
                            Change Destination and Visiting Places
                        </ModalHeader>
                        <ModalBody>
                            <AvForm className="needs-validation" onValidSubmit={this.handleSaveDestinations}>
                                <Row>
                                    <Col md="12">
                                        <div className="mb-3">
                                            <Label className="form-label">Destinations</Label>
                                            <Select 
                                                onInputChange={this.onDestinationInputChange}
                                                value={this.state.selectedDestination}
                                                onChange={this.handleselectedDestination}
                                                options={this.state.DestinationGroup}
                                                classNamePrefix="select2-selection"
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="12">
                                        <div className="mb-3">
                                            <Label className="form-label">Visiting Places</Label>
                                            <Select
                                                onInputChange={this.onInputChange}
                                                value={this.state.selectedVisitingLocation}
                                                onChange={this.handleSelectedVisitingLocation}
                                                isMulti={true}
                                                isLoading={this.state.loading}
                                                options={this.state.DestinationsLocationGroup}
                                                classNamePrefix="select2-selection"
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <FormGroup className="mb-0 mt-3">
                                    {this.state.locationloading ? (
                                        <Spinner className="me-2 mt-2" color="primary" />
                                    ) : (
                                        <div>
                                            <Button type="submit" color="primary" className="me-1">
                                                Update
                                            </Button>
                                        </div>
                                    )}
                                </FormGroup>     
                            </AvForm>
                        </ModalBody>
                    </Modal>
                </Col>

                {this.state.destination_alert_confirm ? (
                    <SweetAlert
                        title="Are you sure?"
                        warning
                        showCancel
                        confirmBtnBsStyle="success"
                        cancelBtnBsStyle="danger"
                        onConfirm={() => this.handleDeleteDestination(this.state.destination_id)}
                        onCancel={() =>
                            this.setState({
                                destination_alert_confirm: false,
                                destination_id: "",
                            })
                        }
                    >
                        You won't be able to revert this!
                    </SweetAlert>
                ) : null}

                {this.state.destination_success_confirm ? (
                    <SweetAlert
                        success
                        title={this.state.dynamic_title}
                        confirmBtnBsStyle="success"
                        cancelBtnBsStyle="danger"
                        onConfirm={() => this.setState({ destination_success_confirm: false, destination_alert_confirm: false })}
                    >
                        {this.state.dynamic_description}
                    </SweetAlert>
                ) : null}
            </React.Fragment>
        );
    }
}

export default DestinationDetail;